module.exports = __webpack_public_path__ + "img/product_71.1fd1de5.webp";